<template>
  <div>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <v-container>
          <h2 class="secondary--text mb-3">Lengkapi Formulir Penugasan Instruktur dibawah ini</h2>
          <v-row>
            <v-col cols="12">
              <div class="info--text body-2"> Akun calon instruktur <span class="red--text">*</span> </div>
              <template v-if="(instruktur && $isObject(instruktur)) || (instrukturBaru && $isObject(instrukturBaru))">
                <v-list-item class="px-0 mb-3">
                  <v-list-item-avatar color="secondary" size="40">
                    <v-icon dark style="font-size: 30px">mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <v-row no-gutters>
                      <v-col cols="12" md="3">
                        <h2 class="body-1 secondary--text">
                          {{ $getDeepObj(instrukturBaru, 'nama') || $getDeepObj(instruktur, 'nama') || '-' }}
                        </h2>
                        <div style="line-height: 1.2">
                          <label class="grey--text">Email: </label>
                          {{ $getDeepObj(instrukturBaru, 'email') || $getDeepObj(instruktur, 'email') || '' }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="8" v-if="action === 'create'">
                        <v-btn dark color="secondary" left @click="onSelectAkun" depressed>
                          <v-icon left>mdi-pencil</v-icon> Ganti Akun
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else>
                <v-btn dark color="secondary" left @click="onSelectAkun" depressed>
                  <v-icon left>mdi-account</v-icon> Pilih Akun
                </v-btn>
              </template>
            </v-col>
            <v-col cols="12">
              <base-form-generator :schema="schema" v-model="form" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <Pengawas ref="instruktur" :masters="masters" />
  </div>
</template>
<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
export default {
  components: {
    Pengawas: () => import('../component/Sumber'),
    BaseFormGenerator,
  },

  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    p4tk: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: null,
    },
    action: {
      type: String,
      default: 'create',
    },
  },

  data() {
    return {
      instruktur: null,
      instrukturBaru: null,
      form: {},
    };
  },

  computed: {
    mJenjang() {
      let result = {};

      for (let kJenjang in this.masters.jenjang) {
        if (kJenjang < 7) {
          result[kJenjang] = this.masters.jenjang[kJenjang];
        }
      }

      return result;
    },

    schema() {
      return [
        {
          type: 'VSelect',
          name: 'instansi_id',
          label: 'Instansi Bertugas',
          labelColor: 'info',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.p4tk),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
          disabled: !!this.$getDeepObj(this, 'initValue.psp_instruktur_id'),
          grid: { cols: 12, md: 4 },
        },
        {
          type: 'VSelect',
          name: 'k_jenjang',
          label: 'Jenjang Diklat',
          labelColor: 'info',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.mJenjang),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
          grid: { cols: 12, md: 2 },
        },
        {
          type: 'VRadio',
          name: 'is_ksps',
          label: 'Instruktur Diklat KSPS',
          labelColor: 'info',
          hint: 'wajib diisi',
          required: true,
          hideDetails: true,
          items: this.$mapForMaster({ 0: 'Tidak', 1: 'Ya' }),
          grid: { cols: 12, md: 3 },
        },
      ];
    },
  },

  methods: {
    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'instruktur', null);
      this.$set(this, 'instrukturBaru', null);
    },

    initForm(value) {
      this.reset();
      const formulir = [...this.schema];
      for (const f of formulir) {
        this.$set(this.form, f.name, (value && value[f.name]) || null);
      }

      if (value.psp_instruktur_id) {
        this.instrukturBaru = {
          nama: this.$getDeepObj(value, 'akun.nama'),
          email: this.$getDeepObj(value, 'akun.email'),
          psp_instruktur_id: value.psp_instruktur_id,
        };

        if (this.form.is_ksps === null) {
          this.form.is_ksps = 0;
        }
      }
    },

    onSelectAkun() {
      this.$refs.instruktur.open('Pilih Calon Instruktur').then((instruktur) => {
        this.instrukturBaru = instruktur;
      });
    },

    getId() {
      return (
        this.$getDeepObj(this, 'instrukturBaru.psp_instruktur_id') || this.$getDeepObj(this, 'instrukturBaru.akun_id')
      );
    },

    getValue() {
      return this.form;
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
